// extracted by mini-css-extract-plugin
export default {"container":"ProductCreator_container__quSDK"};